import React, { useContext } from 'react';

import {
	Route,
	useParams,
	useRouteMatch,
} from 'react-router-dom';

import { setLocale } from './adobeAnalytics';
import nodePath from 'path';

const LocaleContext = React.createContext('en');

let globalLocale = 'en';

export function LocaleProvider(props) {
	let { locale } = useParams();

	if (locale !== 'en' && locale !== 'ar' && locale !== 'jp') {
		locale = window.redemptionInfo?.locale ?? window.ariyaInfo?.locale ?? 'en';
	}

	globalLocale = locale;
	setLocale(locale);

	return <LocaleContext.Provider value={locale ?? 'en'}>{props.children}</LocaleContext.Provider>;
}

Object.assign(window, {
	getLocale(){
		return globalLocale;
	}
});

export function useRelativeRoute(path, children) {
	const routeMatch = useRouteMatch();

	const pathJoined = nodePath.join(routeMatch.path, path);

	return <Route path={pathJoined}>{children}</Route>;
}

export function LocaleRoute(props) {
	const { component: Component } = props;
	return (
		<Route path="/:locale(en|jp|ar)?">
			<LocaleProvider>
				<Component />
			</LocaleProvider>
		</Route>
	);
}

export function useLocale() {
	return useContext(LocaleContext);
}
